module.exports = __webpack_public_path__ + "img/banner-default.0b33a9a6.jpg";